import Vue from "vue";
import Component from "vue-class-component";
// eslint-ignore-next-line
import VCalendar from "v-calendar/lib/components/calendar.umd";
import moment from "moment";
import { mapGetters } from "vuex";

const DatePickerProps = Vue.extend({
  props: {
    showDatePicker: {
      type: Boolean,
      default: false,
    },
  },
});

const todayHightlight = {
  key: "today",
  highlight: {
    style: {
      backgroundColor: "#FFB800",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(242, 202, 0, 0.3)",
    },
    fillMode: "solid",
  },
  dates: new Date(),
};

const locale = { 
  id: 'pt-BR', 
  firstDayOfWeek: 1, 
  masks: { 
    title: 'MMMM YYYY',
    weekdays: 'W',
  }
};
@Component<DatePicker>({
  name: "DatePicker",

  components: {
    VCalendar,
  },
  computed: mapGetters(["getDate", "getClinicId"]),
})
export default class DatePicker extends DatePickerProps {
  getDate!: string;
  getClinicId!: string;

  attrs: any[] = [todayHightlight];
  cx_locale: any = locale;
  selectedDate: any = null;
  cx_disabled_dates: any = [];
  cx_current_date: any = new Date();

  constructor() {
    super();
  }

  mounted(): void {
    if (this.getDate) {
      const dateFormated = new Date(this.getDate);
      this.onDayClick(dateFormated);
    }

    this.formatMonthDays();
    this.formatWeekDays();
    this.formatTitle();

    document.querySelectorAll(".vc-arrows-container")?.forEach((arrow) => {
      arrow.addEventListener("click", () => {
        setTimeout(() => {
          this.formatMonthDays();
          this.formatWeekDays();
          this.formatTitle();
        }, 200);
      })
    }); 
  }
  
  formatTitle(): void {
    const title = document.querySelector<HTMLElement>(".vc-title")?.innerText || "";
    const formattedTitle = title?.charAt(0).toUpperCase() + title?.slice(1);

    document.querySelector<HTMLElement>(".vc-title")!.innerText = formattedTitle;
  }

  formatMonthDays(): void {
    const dayElements = Array.from(document.querySelectorAll<HTMLElement>(".vc-day-content"));

    dayElements.forEach((day, index) => {
      if (day.innerText.length !== 2) {
        dayElements[index].innerText = `0${day.innerText}`;
      }
    });
  }

  formatWeekDays(): void {
    const dayElements = Array.from(document.querySelectorAll<HTMLElement>(".vc-weekday"));

    dayElements.forEach((day, index) => {
      switch(index) {
        case 0:
          dayElements[index].innerText = "Dom";
          break;
        case 1:
          dayElements[index].innerText = "Seg";
          break; 
        case 2:
          dayElements[index].innerText = "Ter";
          break; 
        case 3:
          dayElements[index].innerText = "Qua";
          break;
        case 4: 
          dayElements[index].innerText = "Qui";
          break;
        case 5:
          dayElements[index].innerText = "Sex";
          break;
        case 6:
          dayElements[index].innerText = "Sab";
          break;
      }
    });
  }

  onDayClick(day: any) {
    if (day.id) {
      this.selectedDate = day.date;
    } else {
      this.selectedDate = day;
    }
    
    const formattedDate = moment(this.selectedDate).locale("pt").format("dddd DD [de] MMMM YYYY");
    if (moment(day.id).diff(moment(new Date()).format("YYYY-MM-DD")) < 0) return false;

    const todayLocaleDate = moment(new Date()).format("YYYY-MM-DD");
    const selectedDateLocaleDate = moment(this.selectedDate).format("YYYY-MM-DD");

    let colorDate, borderShadow = "";

    if (selectedDateLocaleDate >= todayLocaleDate && !day.isDisabled) {
      if (this.$route.name === "SearchServicesTenancy" || this.$route.name === "ClinicScreen") {
        colorDate = "#FF9100";
        borderShadow = "0px 4px 10px rgba(255, 145, 0, 0.32)";
      } else {
        colorDate = "#009EAD";
        borderShadow = "0px 4px 10px rgba(0, 177, 172, 0.32);";
      }
    } else {
      this.selectedDate = "";
    }

    const selectedHighlight = {
      key: "selected",
      highlight: {
        style: {
          backgroundColor: colorDate,
          borderRadius: "4px",
          borderShadow: borderShadow,
        },
        fillMode: "solid",
      },
      dates: this.selectedDate,
    };

    if (todayLocaleDate !== selectedDateLocaleDate)
      this.attrs = [todayHightlight, selectedHighlight];
    else this.attrs = [selectedHighlight];

    this.$emit("selectedDate", formattedDate);
    this.$store.commit("setAppointmentDate", moment(this.selectedDate).locale("pt").format("dddd DD/MM/YYYY"));
    this.$store.commit("setDate", this.selectedDate.toString());
  }
}
